import styled from 'styled-components';
import { Colors } from '~/config/Colors';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  width: 100%;
  height: 100%;
  padding: 16px;
  margin-bottom: 24px;

  border-radius: 20px;
`;

export const FiltersContainer = styled.div`
  display: grid;
  grid-template-columns: 2fr repeat(2, 1fr);
  align-items: flex-end;
  gap: 16px;
  width: 100%;
`;

export const Table = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${Colors.bgCardColor};

  border-radius: 12px;
  text-align: center;

  border: 1px solid ${Colors.Border_Color_1};
  box-shadow: rgba(0, 0, 0, 0.3) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
`;

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 2fr repeat(4, 1fr) 100px;
  width: 100%;
  padding: 24px;
  gap: 16px;
  background-color: #6796cf;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;

  font-size: 16px;
  color: ${Colors.Color30};
  font-weight: 500;
  line-height: 24px;
`;

export const TableBody = styled.div`
  display: grid;
  grid-template-columns: 2fr repeat(4, 1fr) 100px;
  align-items: center;
  width: 100%;
  padding: 24px;
  gap: 16px;

  font-size: 16px;
  color: ${Colors.text_Color_1};
  font-weight: 300;
  line-height: 24px;

  border-bottom: 1px solid
    ${props => (props.hasBorder ? `${Colors.Border_Color_1}` : 'transparent')};
  &:last-child {
    border-bottom: none;
  }
`;

export const TableBodyNobody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  height: 200px;
  width: 100%;
  padding: 24px;
  gap: 16px;

  font-size: 16px;
  color: ${Colors.Color30};
  font-weight: 300;
  line-height: 24px;
  text-align: center;
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;
